import React from 'react';

const PilatesYogaPage = () => {
  return (
    <div>
      <h1>Pilates & Yoga</h1>
    </div>
  );
};

export default PilatesYogaPage;
